import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "relative w-full min-w-[180px] max-w-[292px] hover:cursor-pointer group" }
const _hoisted_2 = { class: "h-10 w-full flex text-sm leading-7 bg-white border border-zbr-gray-300 hover:shadow-border-gray-300 transition-shadow" }
const _hoisted_3 = { class: "ml-[7px] mr-1 text-zbr-gray-700 text-left font-roboto-condensed" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass([
            'absolute top-9 left-0 w-full z-20 -mt-0.5 px-3 pb-3 bg-white border border-zbr-gray-300',
            'before:absolute before:-top-px before:left-0 before:w-full before:h-px before:bg-white',
          ])
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass([
              'h-auto max-h-[154px] pt-1.5 overflow-y-auto border-t-2 border-zbr-gray-300',
            ])
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "font-roboto-condensed text-sm text-zbr-black-900" }

import IconCaret from '@/components/icons/IconCaret.vue';
import IconSorting from '@/components/icons/IconSorting.vue';
import IconClose from '@/components/icons/IconClose.vue';
import { BaseSortingDropdownItem } from '@/utils/types/index';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSortingDropdown',
  props: {
    placeholder: {},
    items: {},
    className: {}
  },
  emits: ['on-select-item', 'on-clear'],
  setup(__props: any, { expose: __expose, emit }) {




const selectedLabel = ref('');
const isOpen = ref(false);
const isSelected = ref(false);

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}
function hideDropdown() {
  isOpen.value = false;
}
function selectItem(item: BaseSortingDropdownItem) {
  isSelected.value = true;
  selectedLabel.value = item.label;
  isOpen.value = false;
  emit('on-select-item', item);
}
function clearItem() {
  selectedLabel.value = '';
  isSelected.value = false;
  emit('on-clear');
}
function iconAction() {
  if (isSelected.value && isOpen.value) {
    clearItem();
  } else {
    toggleDropdown();
  }
}
function reset() {
  clearItem();
}

__expose({
  reset,
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.className)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", _hoisted_2, [
        _createElementVNode("p", {
          class: "relative flex w-auto h-auto self-center text-left overflow-hidden",
          onClick: toggleDropdown
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(IconSorting, {
              "class-name": 'inline-block -mt-0.5',
              "class-stroke": 'stroke-zbr-gray-400 group-hover:stroke-zbr-primary'
            })
          ]),
          _createElementVNode("span", {
            class: _normalizeClass([
              'text-left font-roboto-condensed whitespace-nowrap',
              selectedLabel.value ? 'text-zbr-black-900 grou-hover:text-zbr-primary' : 'text-zbr-gray-700 group-hover:text-zbr-primary',
            ])
          }, _toDisplayString(_ctx.$t(selectedLabel.value) || _ctx.placeholder), 3)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass([
            'w-zbr-medium h-full mr-0 ml-auto',
            'after:absolute after:top-2 after:right-[32px] after:h-full after:max-h-[22px] after:w-px after:bg-zbr-gray-300',
          ]),
          onClick: iconAction
        }, [
          _createElementVNode("span", {
            class: _normalizeClass([
              isSelected.value && isOpen.value ? 'hidden' : 'block'
            ])
          }, [
            _createVNode(IconCaret, {
              "class-name": "ml-auto mr-[10px] mt-1.5",
              "class-fill": "fill-zbr-gray-400 group-hover:fill-zbr-primary",
              size: 24
            })
          ], 2),
          _createElementVNode("span", {
            class: _normalizeClass([
              isSelected.value && isOpen.value ? 'block' : 'hidden',
            ])
          }, [
            _createVNode(IconClose, {
              "class-name": "ml-auto mt-3.5 mr-3",
              "class-stroke": "stroke-zbr-gray-700",
              size: 10
            })
          ], 2)
        ])
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration 100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: `${item.label}-${index}`,
                  class: "block w-full py-0.5 pl-5 pr-2 leading-6 hover:bg-zbr-primary/[.1] border-b border-zbr-gray-200",
                  onClick: ($event: any) => (selectItem(item))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(item.label)), 1)
                ], 8, _hoisted_6))
              }), 128))
            ])
          ], 512), [
            [_vShow, isOpen.value]
          ])
        ]),
        _: 1
      })
    ])
  ], 2)), [
    [_directive_click_outside, hideDropdown]
  ])
}
}

})